import { getDb, type SkimFindingRecord } from './db';

/**
 * Upsert findings while preserving any prior `editorAction` value. This is what
 * makes confirm/dismiss persist across re-analyses: the runner produces fresh
 * record candidates each time, but the editor's prior decisions stick.
 */
export async function upsertFindings(records: SkimFindingRecord[]): Promise<void> {
  if (records.length === 0) return;
  const db = await getDb();
  const tx = db.transaction('skim_findings', 'readwrite');
  await Promise.all(
    records.map(async (r) => {
      const existing = await tx.store.get(r.id);
      const editorAction = existing?.editorAction ?? r.editorAction;
      await tx.store.put({ ...r, editorAction });
    }),
  );
  await tx.done;
}

/** @deprecated alias of upsertFindings; kept for older call sites. */
export const bulkInsertFindings = upsertFindings;

export async function findingsBySkim(skimReportId: string): Promise<SkimFindingRecord[]> {
  const db = await getDb();
  return db.getAllFromIndex('skim_findings', 'by_skim_report', skimReportId);
}

export async function updateFindingAction(
  id: string,
  editorAction: SkimFindingRecord['editorAction'],
): Promise<void> {
  const db = await getDb();
  const existing = await db.get('skim_findings', id);
  if (!existing) return;
  await db.put('skim_findings', { ...existing, editorAction });
}
